import styled from 'styled-components'

type TypeCardCategoryDetail ={
    text?:string
    lastImage?: boolean
    src?:string|null
    discount?: number | null
    secondImage?:string
    bgColor?:string
    display?: string
}

const CategoriesDetailContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(25em, 1fr));
    @media (max-width: ${props => props.theme.breakpoints.md}){
      grid-template-columns: grid;
      grid-template-columns: repeat(auto-fill,minmax(20em, 1fr)); 
      background-color: white;
      padding-bottom: 35px;
    }  

    @media (max-width: ${props => props.theme.breakpoints.xs}){
      grid-template-columns: grid;
      grid-template-columns: repeat(2, 1fr); 
      background-color: white;
      padding-bottom: 35px;
      align-items: baseline;
    }  
`

const CategoriesDetailContainerRow = styled.div`
    @media (max-width: ${props => props.theme.breakpoints.md}){
      grid-template-columns: none;
      grid-auto-rows: 1fr;    
      background-color: white;
      padding-top: 20px;
    }   
`

const ProductNameRow = styled.div<TypeCardCategoryDetail> `
    font-family: Open Sans;
    font-size: 32px;
    color: #999999;
     @media (max-width: ${props => props.theme.breakpoints.md}){
        font-size: 14px;    
    };
`

const PriceRow = styled.div<TypeCardCategoryDetail>`
    font-family: Open Sans;
    font-weight: bold;
    font-size: 30px;
    color: #222222;
    margin-top: 14px;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        font-size: 16px;   
        margin-top: 3px; 
    };
`

const RegularPriceRow = styled.div`
        font-family: Open Sans;
        font-size: 16px;
        text-decoration-line: line-through;    
        color: #999999;
        margin-top: 28px;
        // margin-left: 15px;
        @media (max-width: ${props => props.theme.breakpoints.md}){
            font-size: 16px;         
            margin-top: 2px;
            margin-left: 0;
        };
    `
const DescriptionRow = styled.div`
        font-family: Open Sans;
        font-size: 16px;
        color: #444444;
        margin-top: 40px;
        margin-left: 0px;
        margin-right: 30px;
        text-align: justify;
        @media (max-width: ${props => props.theme.breakpoints.md}){
            font-size: 12px;    
            margin-top: 5px;
            width: 170px;
         };  
         @media (min-width: ${props => props.theme.breakpoints.md}){
            width: 270px;
         };  
    `

const ContainerCardCategoryDetail = styled.div<TypeCardCategoryDetail>`
    justify-content:center;
    margin: 40px 20px;
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: none;  
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display: none;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}){
        justify-content: center;
        align-items: center;        
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}){
        justify-content:${props => props.lastImage ? "center" : "flex-start"};
        margin: 1vh;
    }
    
`

const DivRow = styled.div`
    margin-left: 52px;
    @media (max-width: ${props => props.theme.breakpoints.md}){
            margin-left: 14px  
        };  
`

const CardImgRow = styled.div<TypeCardCategoryDetail>`
width: 100%;
max-width: 320px;
height: 320px;
max-height:320px;
border-radius:10px;
background-size: 100% 100%;
background-image:url(${props => props.src});
@media (max-width: ${props => props.theme.breakpoints.xs}){
    height: 120px;
    border-bottom-left-radius:0;
    border-bottom-right-radius:0;
}; 
`

const CardRow = styled.div<TypeCardCategoryDetail>`
   position:relative;
   text-align: center;
   overflow:hidden;
   min-width: 320px;
   cursor: pointer;
   border-radius:10px;
   display: inline-block;
   vertical-align: top;
   margin-right: 30px;
   &:hover ${CardImgRow}{
    background-image :url( ${props => props.secondImage});
    }
   @media (max-width: ${props => props.theme.breakpoints.md}){
       min-width: ${props => props.display === 'tablet' ? '300px' : '160px'};
       margin-right: 0;
       justify-content: center;
       flex-direction: column;
       align-items: center;
       &:after, &:before {
        right: 20px;
       };
   }
`

const ContainerGeneralMap = styled.div<TypeCardCategoryDetail> `
    display: flex;
    margin-bottom: 50px;
    margin-left: 18px;
    width: auto;
`

const Line = styled.div<TypeCardCategoryDetail> `
    margin-bottom: 48px;
    border-bottom: solid 1px #F6F6F6;
    @media (max-width: ${props => props.theme.breakpoints.xs}){
        margin-top: -20px;
        margin-bottom: 28px;
        border-bottom: solid 1px #E4E4E4;
    } 
`

const LineNameRow = styled.div<TypeCardCategoryDetail> `
    border-bottom: solid 1px #F6F6F6;
    width: 25em;
    @media (max-width: ${props => props.theme.breakpoints.xs}){
        margin-top: -20px;
        margin-bottom: 28px;
    } 
`
   

export {CategoriesDetailContainer,
    CategoriesDetailContainerRow,
    ProductNameRow,
    PriceRow,
    RegularPriceRow,
    DescriptionRow,
    ContainerCardCategoryDetail,
    DivRow,
    CardImgRow,
    CardRow,
    Line,
    ContainerGeneralMap,
    LineNameRow
}